<a id="downloadLink" class="nav__link" calltoaction [calltoactionTemplate]="downloadTemplateRef" calltoactionPosition="bottom" (calltoActionOnShow)="onShow()" calltoactionMaxWidth="400px" [calltoactionKeepWithinBoundary]="true">
  <i class="material-icons md-24 md-align lock-img-align nav__link_icon" style="font-size: 26px; margin-left: -2px;" title="Exports">download</i>
</a>

<ng-template #downloadTemplateRef>
  <div style="width: 380px;">
    @if (isLoading) {
      <div class='loading-spinner'></div>
    }
    @if (!isLoading) {
      <div>
        @if (data.length == 0) {
          <div><div style="text-align: center; line-height: 50px;">No files available</div></div>
        }
        @if (data.length > 0) {
          <div>
            <div class="block">
              <div class="left"><strong>Exports</strong></div>
              <div class="right">Files are available until 11:59 PM ET</div>
              <br class="clear"/>
            </div>
            <table class="export-table">
              <tr class="header">
                <td class="">
                  <div class="left"><strong>File</strong></div>
                  <span class="left clickable" style="margin-left: 40px;" (click)="$event.stopPropagation(); getList()"><i class="material-icons md-24 md-align" style="color: #0671da" title="Refresh">autorenew</i> (Refresh if file not ready)</span>
                  <br class="clear"/>
                </td>
                <td style="width: 100px"><strong>Status</strong></td>
              </tr>
            </table>
            <div style="width: 100%; max-height: 200px; overflow-y: auto;">
              <table class="export-table">
                @for (item of data; track item; let i = $index) {
                  <tr>
                    <td style="vertical-align: top; padding: 5px 10px 5px 0;">
                      <div class="truncate" style="line-height: 15px;">
                        @if (item.fileStatus == 'READY') {
                          <a (click)="download(item.exportId)" title="{{item.displayFileName}}">{{item.displayFileName}}</a>
                        }
                        @if (item.fileStatus != 'READY') {
                          <div title="{{item.displayFileName}}">{{item.displayFileName}}</div>
                        }
                      </div>
                      <div style="line-height: 15px;">submitted {{item.createdDate | date:'MM/dd/yyyy h:mm a'}} ET</div>
                    </td>
                    <td [style]="{'width': (data.length > 5 ? '84px' : '100px')}" style="vertical-align: top; padding: 5px 0;"><div style="line-height: 15px;">{{item.fileStatus.charAt(0)}}{{item.fileStatus.substring(1).toLowerCase()}}</div></td>
                  </tr>
                }
              </table>
            </div>
          </div>
        }
      </div>
    }
  </div>
</ng-template>
